import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import DatePickerCustom from './DatePickerCustom';
import apiClient from '../../../../Services/NetteApiClient';
import { format, parseISO } from 'date-fns';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-date-picker-custom',
	callback: ({ container, context }: any) => {
		const changeUrl = container.getAttribute('onchangeurl');
		const value = container.getAttribute('value');
		const minDate = container.getAttribute('minDate');
		const maxDate = container.getAttribute('maxDate');

		const handleChange = (date: Date) => {
			apiClient.post(changeUrl, {
				date: format(date, 'yyyy-MM-dd'),
			});
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DatePickerCustom
						onChange={handleChange}
						value={value}
						minDate={minDate}
						maxDate={maxDate}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
